import React, { useState, useEffect, useRef } from 'react';
import {
  FaHome,
  FaMoneyBillWave,
  FaClipboardList,
  FaCalendarCheck,
  FaChartBar,
  FaCog,
  FaSignOutAlt,
  FaBars,
  FaTimes,
  FaBook,
  FaBell,
  FaUsers,
  FaTicketAlt,
  FaBuilding,
  FaBlog,
  FaUserShield,
  FaProjectDiagram,
  FaAngleLeft,
  FaComments,
} from 'react-icons/fa';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import '../../../assests/css/admin/Adminsidebar.css';

import { FaCmplid, FaManatSign } from 'react-icons/fa6';
import { MdManageAccounts } from 'react-icons/md';

/* ─── Menu Items ─────────────────────────────────── */
const menuItems = [
  
  { label: 'Dashboard',         icon: <FaHome />,           path: '/admin/dashboard' },
  { label: 'Sub Admin',         icon: <FaUserShield />,     path: '/sub/admin/management' },
  // { label: 'Students',          icon: <FaUsers />,          path: '/admin/user/management' },
  { label: 'Teachers',          icon: <FaUsers />,          path: '/admin/teacher/management' },
  { label: 'Departments',       icon: <FaBuilding />,       path: '/admin/departments' },
    { label: 'Program',           icon: <FaProjectDiagram />, path: '/admin/program/management' },
  { label: 'Course', icon: <FaBook />,           path: '/course/semester/management' },
    { label: 'Fee',               icon: <FaMoneyBillWave />,  path: '/admin/fees' },
  { label: 'Exam',              icon: <FaClipboardList />,  path: '/admin/exam/management' },
// { label: 'Attendance',        icon: <FaCalendarCheck />,  path: '/admin/attendance' },
    { label: 'Blog',              icon: <FaBlog />,           path: '/admin/blog' },
      { label: 'Cms',              icon: <MdManageAccounts  />,           path: '/admin/cms/management' },
  { label: 'Reports',           icon: <FaChartBar />,       path: '/admin/reports' },
 { label: 'Help Support',          icon: <FaTicketAlt />,      path: '/admin/disputes/support' },
  { label: 'Notifications',     icon: <FaBell />,           path: '/admin/notifications' },
  { label: 'AdminDispute',               icon: <FaMoneyBillWave />,  path: '/admin/dispute' },
  { label: 'Settings',          icon: <FaCog />,            path: '/admin/setting' },
];

/* ─── Adminsidebar ───────────────────────────────── */
const Adminsidebar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed,  setCollapsed]  = useState(false);

  const location  = useLocation();
  const navigate  = useNavigate();
  const sidebarRef = useRef(null);

  // close drawer on route change
  useEffect(() => { setMobileOpen(false); }, [location.pathname]);

  // close drawer when viewport becomes desktop
  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 768) setMobileOpen(false);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  // lock body scroll while drawer is open
  useEffect(() => {
    document.body.style.overflow = mobileOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [mobileOpen]);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/admin/login');
  };

  return (
    <>
      {/* ── TOP NAVBAR (mobile only) ── */}
      <header className="sb-topbar">
        <div className="sb-topbar-left">
          <button
            className="sb-hamburger"
            onClick={() => setMobileOpen(true)}
            aria-label="Open navigation"
          >
            <FaBars />
          </button>
          <span className="sb-topbar-title">GGCW Admin</span>
        </div>
        <img
          src="https://api.dicebear.com/7.x/avataaars/svg?seed=AdminX"
          alt="Admin"
          className="sb-topbar-avatar"
        />
      </header>

      {/* ── DARK OVERLAY (mobile) ── */}
      {mobileOpen && (
        <div
          className="sb-overlay"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* ── SIDEBAR ── */}
      <aside
        ref={sidebarRef}
        className={[
          'admin-sidebar',
          mobileOpen ? 'is-open'      : '',
          collapsed  ? 'is-collapsed' : '',
        ].filter(Boolean).join(' ')}
      >
        {/* Collapse toggle — desktop only */}
        <button
          className="sb-collapse-toggle"
          onClick={() => setCollapsed(v => !v)}
          aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          <FaAngleLeft />
        </button>

        {/* Close button — mobile only */}
        <button
          className="sb-close"
          onClick={() => setMobileOpen(false)}
          aria-label="Close navigation"
        >
          <FaTimes />
        </button>

        {/* ── Profile ── */}
        <div className="sb-profile">
          <div className="sb-avatar">
            <img
              src="https://api.dicebear.com/7.x/avataaars/svg?seed=AdminX"
              alt="Admin"
            />
            <span className="sb-online-dot" />
          </div>
          <div className="sb-profile-info">
            <p className="sb-name">Admin Panel</p>
            <p className="sb-email">admin@college.com</p>
          </div>
        </div>

        {/* ── Navigation ── */}
        <nav className="sb-nav" aria-label="Admin navigation">
          <ul>
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  className={({ isActive }) =>
                    'sb-link' + (isActive ? ' sb-link--active' : '')
                  }
                >
                  <span className="sb-icon">{item.icon}</span>
                  <span className="sb-label">{item.label}</span>
                  <span className="sb-tooltip">{item.label}</span>
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* ── Logout ── */}
        <div className="sb-footer">
          <button className="sb-logout" onClick={handleLogout}>
            <span className="sb-icon"><FaSignOutAlt /></span>
            <span className="sb-label">Logout</span>
            <span className="sb-tooltip">Logout</span>
          </button>
        </div>
      </aside>
    </>
  );
};

export default Adminsidebar;